import React, { useState } from "react";
import LoginForm from "../../components/login";
import logoLight from "../../assets/images/logo.png";
import logoDark from "../../assets/images/logo.png";

const LoginPage = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <div className="login-page">
      <div className="left-panel">
        <p className="left-logo">
          <img
            src={isDarkMode ? logoDark : logoLight}
            alt="healthscope.ai"
            className="d-inline-block align-top"
          />
        </p>
      </div>

      <div className="right-panel">
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
